module.exports = __webpack_public_path__ + "img/oman.d046fdd1.svg";